import { ServiceStatus } from "@/models/enums/service";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { mergeObjects } from "@/utils/utils";
import axios from "axios";

// Interface
interface OntradeDashoboardState {
  ontrade: {
    network: {
      code: ServiceStatus;
      error?: string;
    };
    data?: any;
  };
}

// Initialize State
const initialState: OntradeDashoboardState = {
  ontrade: {
    network: {
      code: ServiceStatus.idle,
      error: undefined,
    },
    data: undefined,
  },
};

/**
 * @link https://redux-toolkit.js.org/api/createSlice
 */
export const dashboardOntradeSlice = createSlice({
  name: "dashboard_ontrade",
  initialState,
  //basic state change
  reducers: {
    reset: () => initialState,
    patch: (state, action) => mergeObjects({ ...state }, action.payload),
  },
  //async trunk state change
  extraReducers(builder) {
    // Fetch MSK
    builder.addCase(onFetchOnTrade.pending, (state, action) => {
      state.ontrade.network.code = ServiceStatus.loading;
    });
    builder.addCase(onFetchOnTrade.rejected, (state, action) => {
      state.ontrade.network.error = action.error.message;
      state.ontrade.network.code = ServiceStatus.failed;
    });
    builder.addCase(onFetchOnTrade.fulfilled, (state, action) => {
      if (action.payload && action.payload != null) {
        state.ontrade.data = action.payload;
      } else {
        state.ontrade.data = undefined;
      }
      state.ontrade.network.code = ServiceStatus.succeeded;
    });
  },
});

export const onFetchOnTrade = createAsyncThunk("reports/OnTrade", async (param: any = {}, thunkAPI) => {
  try {
    const res = await axios.post(`api/DashBoard/GetSaleDashboardOntradeChannel`, param);
    return res.data.data;
  } catch (error: any) {
    // Handle any errors and return an error action
    return thunkAPI.rejectWithValue(error.message);
  }
});

export const { reset, patch } = dashboardOntradeSlice.actions;

export default dashboardOntradeSlice.reducer;
